import { FC, ReactElement } from 'react'

import { SvgIconProps } from '@/components/Icon/Icon'

export const IconGroup: FC<SvgIconProps> = ({ className = '' }): ReactElement => (
    <svg
        className={`icon-component ${className}`}
        viewBox="0 0 24 24"
        strokeWidth="2"
    >
        <path className="stroke" d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
        <circle className="stroke" cx="9" cy="7" r="4" />
        <path className="stroke" d="M23 21v-2a4 4 0 0 0-3-3.87" />
        <path className="stroke" d="M16 3.13a4 4 0 0 1 0 7.75" />
    </svg>
)
